module.exports = __webpack_public_path__ + "static/media/quotes-right2.8feb5ac6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/quotes-right2.svg
// module id = 3415
// module chunks = 7